<template>
  <v-form ref="form">
    <v-container grid-list-md>
      <v-layout v-if="!ui.loading">
        <v-flex xs12>
          <v-toolbar color="pink" dark>
            <v-icon>key</v-icon>
            <v-toolbar-title>Change Password</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field v-model="identity.username" label="User Name" :readonly="true"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model="password" type="password" :rules="ui.passwordRules" label="New Password"></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red lighten-1" dark :to="{ name: 'home' }">Cancel</v-btn>
              <v-btn color="primary" :loading="ui.loading" @click="save">Update</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout v-if="ui.loading">
        <v-flex>
          <v-card>
            <div class="text-xs-center pa-3">
              <v-progress-circular indeterminate color="green"></v-progress-circular>
            </div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-snackbar v-model="ui.snackbar" :color="ui.snackbarMode" :timeout="5000">
      <span>{{ ui.feedback }}</span>
      <v-btn dark flat @click="ui.snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-form>
</template>

<script>
import { mapState } from "vuex";
export default {
  data: function() {
    return {
      password: "",
      ui: {
        passwordRules: [
          function(x) {
            return x && x.length >= 8 ? true : "This field is required and should be minimum 8 characters";
          },
          function(x) {
            return /\d/.test(x) ? true : "Password needs atleast one number and a letter";
          },
          function(x) {
            return /\w/.test(x) ? true : "Password needs atleast one letter and a number";
          },
        ],
        snackbar: false,
        feedback: "",
        snackbarMode: "success",
        showConfirm: false,
        isDirty: false,
        loading: false,
      },
    };
  },
  computed: {
    ...mapState("config", ["identity"]),
  },
  mounted: function() {
    if (!this.identity.username || !this.identity.token) {
      this.$router.push({ name: "login" });
    }
  },
  methods: {
    save: async function() {
      if (!this.$refs.form.validate()) return;

      var profile = { password: this.password };
      var endpoint = this.$api("userprofile");
      this.ui.loading = true;
      try {
        await endpoint.post(profile);
        this.showsnackBar("Saved successfully!", "success");
        this.$router.push({ name: "home" });
      } catch (ex) {
        var msg = ex && ex.responseJSON ? ex.responseJSON.feedback || (ex.responseJSON.Password? ex.responseJSON.Password.join(","):"Invalid request") : "An error occured!";
        this.showsnackBar(msg, "error");
      }
      this.ui.loading = false;
    },
    cancel: function() {},
    showsnackBar: function(msg, mode) {
      this.ui.feedback = msg;
      this.ui.snackbar = true;
      this.ui.snackbarMode = mode || "info";
    },
  },
};
</script>

<style></style>
